// Setup Vue
import { createApp } from 'vue'
window.Vue = createApp;
window.$ = window.jQuery = jQuery;

// Our extensions and components
import Axios from './classes/Axios.js';
import modalDynamic from './components/modal-dynamic.vue';
import UtilitiesMixin from './mixins/UtilitiesMixin';
require ('./classes/PrototypeExt.js');

var app = createApp({

    components: {
      'modal-dynamic': modalDynamic,
    },
    mixins: [UtilitiesMixin],
    data() {
        return {
            oasisApi:'',
            true: true,  // necessary to pass a boolean true and not a string
            false: false,  // necessary to pass a boolean true and not a string
            modals: [],  // Dynamic modals
            openModals: 0,  // Dynamic modals counting
            buttonYesAction: [],
            buttonNoAction: [],
            button3Action: [],

            login: '',
            password: '',
            token: token,
            tokenKey: tokenKey,
            hash: null
        }
    },

    computed: {
    },

    methods: {
        submitLogin() {
            if (! this.login || ! this.password) {
                this.createDialog ({ "title": "Error", "body": "Please enter your email and password", "buttonNo": false, "buttonYesLabel": "OK"  });
                return false;
            }

            let data = {
                email: this.login,
                password: this.password,
                token: this.token,
                tokenKey: this.tokenKey,
                returning: this.hash
            }

            this.oasisApi = new Axios('/restv2');
            this.oasisApi.post('/employeeLogin', data)
                .then(response => {
                    if (response.status === 200 && response.data === false) {
                        // No data to retrive
                        return true;
                    } else if (response.status === 200 && typeof response.data === 'object') {
                        if (localStorage.getItem("showPaycheckBanner")) localStorage.removeItem("showPaycheckBanner");
                        if (localStorage.getItem("showPaperlessBanner")) localStorage.removeItem("showPaperlessBanner");
                        this.createDialog ({ "title": "Success", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK"  });
                        if( this.isMobile() ) {
                            // redirects if mobile
                            window.location.href = '/oasis/employee/index';
                        } else {
                            // redirects if whatever else
                            window.location.href = response.data.forward;
                        }
                    } else if (response.status === 400 || response.status === 403 && typeof response.data === 'object') {
                        this.createDialog ({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK"  });
                    } else if (response.status === 400 || response.status === 403) {
                        this.createDialog ({ "title": "Error", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                    }
                })
                .catch(error => { console.log(error); }
            );
        },

        // Create a dynamic modal dialog box with buttons and labels
        createDialog(options) {
            let index = this.openModals;
            options.id = index;

            if (options.buttonYesAction) { this.buttonYesAction[index] = options.buttonYesAction;
            } else { this.buttonYesAction[index] = function () {}; }

            if (options.buttonYesLabel) { this.buttonYesLabel = options.buttonYesLabel;
            } else { options.buttonYesLabel = 'Yes'; }

            if (options.buttonNoAction) { this.buttonNoAction[index] = options.buttonNoAction;
            } else { this.buttonNoAction[index] = function () {}; }

            if (options.buttonNoLabel) { this.buttonNoLabel = options.buttonNoLabel;
            } else { options.buttonNoLabel = 'No'; }

            if (options.button3Action) { this.button3Action[index] = options.button3Action;
            } else { this.button3Action[index] = function () {}; }

            if (options.button3Label) { this.button3Label = options.button3Label;
            } else { options.button3Label = 'Maybe'; }

            this.modals.push(options);
            this.openModals++;
        },

        // Close the dynamic modal
        closeModal(index) {
            this.modals.splice(index, 1);
            this.buttonYesAction.splice(index, 1);
            this.buttonNoAction.splice(index, 1);
            this.button3Action.splice(index, 1);
            this.openModals--;
        },

        modalConfirm(index) {
            this.buttonYesAction[index]();
        },

        modalCancel(index) {
            this.buttonNoAction[index]();
        },

        modalButton3(index) {
            this.button3Action[index]();
        },
    },

    watch: {
    },

    mounted() {
        // Load data provided by server, if any
        if (email) this.login = email;
        if (typeof hash !== 'undefined') this.hash = hash;
        $("#login").focus();
    }

}).mount("#employee-login");